import Tabs from './Tabs';
import TabPane from './TabPane';

Tabs.Pane = TabPane;

export default Tabs;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/tabs/index.js
// module id = 452
// module chunks = 0